@let gridData = $gridData();
@let T = gridData.data;

<unity-grid-shared
  gridTitle="Disbursements"
  [gridData]="gridData"
  [gridError]="$gridError()"
  [gridLoading]="$gridLoading()"
  [defaultSort]="defaultSort"
  (dataQueryEvent)="onDataQuery($event)">
  <kendo-grid-column field="reference_number_display" title="Disbursement Id">
    <ng-template let-item kendoGridCellTemplate [unityTyped]="T">
      <unity-link-gridcell-shared
        [displayText]="item.reference_number_display"
        [link]="['/agreement', $agreementId(), 'disbursement', item.id]" />
    </ng-template>
  </kendo-grid-column>
  <kendo-grid-column field="date" title="Date" filter="date">
    <ng-template let-item kendoGridCellTemplate [unityTyped]="T">
      {{ item.date | dateTimezone: 'MM/dd/yyyy' }}
    </ng-template>
  </kendo-grid-column>
  <kendo-grid-column field="amount" title="Amount" filter="numeric" class="align-right">
    <ng-template let-item kendoGridCellTemplate [unityTyped]="T">
      {{ item.amount | currency }}
    </ng-template>
  </kendo-grid-column>
  <kendo-grid-column field="current_state.name" title="Status">
    <ng-template let-item kendoGridCellTemplate [unityTyped]="T">
      <unity-chip-workflow-state-shared [name]="item.current_state.name" [value]="item.current_state.enum_value" />
    </ng-template>
  </kendo-grid-column>
</unity-grid-shared>
